export const SEASONS_LIST_KEY = 'leasing-seasons'

export const seasonsListKey = (
    apartmentId: number | undefined,
    includeArchived = false,
) => [SEASONS_LIST_KEY, apartmentId, includeArchived] as const

export const seasonDetailKey = (seasonId: number | null | undefined) =>
    ['leasing-season', seasonId] as const

export const PIPELINE_COUNTS_KEY = 'leasing-season-pipeline-counts'

export const pipelineCountsKey = (
    seasonId: number | null | undefined,
    search?: string,
) => [PIPELINE_COUNTS_KEY, seasonId, search?.trim() || ''] as const

export const marketingChannelsKey = (seasonId: number | null | undefined) =>
    ['leasing-season-marketing-channels', seasonId] as const

export const seasonPipelineDefinitionKey = (
    seasonId: number | null | undefined,
) => ['leasing-season-pipeline-definition', seasonId] as const

/** Detail queries stay fresh for 60s; avoids refetch on tab switches. */
export const SEASON_DETAIL_STALE_MS = 60_000
